<template>
  <DataListStateful
    title="Клиенты"
    resource="clients"
    store="clients"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Корпоративный телефон", name: "phone", sortable: true },
        { title: "Корпоративный Email", name: "email", sortable: true },
        {
          title: "Адрес",
          name: "address",
          dataPath: "Address.Title",
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "manager",
          dataPath: "Manager.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        address: {
          title: "Адрес",
          type: "reference",
          resource: "addresses",
        },
        manager: {
          title: "Менеджер",
          type: "reference",
          resource: "employees",
        },
      },
    };
  },
};
</script>
